import React, { Component } from 'react'

import Dialog from 'components_new/atoms/Dialog'
import DialogTitle from 'components_new/atoms/Dialog/DialogTitle'
import DialogContent from 'components_new/atoms/Dialog/DialogContent'
import DialogActions from 'components_new/atoms/Dialog/DialogActions'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

import { useAlertActions } from 'redux/actions/Applications/Alert'
import { useAlert } from 'redux/hooks/Applications/Alert'

class Alert extends Component {
  state = {
    faIcon: null
  }

  componentDidUpdate(prevProps) {
    const { AlertStore } = this.props

    if (prevProps.AlertStore.faIcon !== AlertStore.faIcon) {
      this.setState({ faIcon: AlertStore.faIcon })
    }
  }

  render() {
    const { faIcon } = this.state
    const { AlertStore, resetAlert } = this.props

    return (
      <Dialog sx={{ zIndex: 2002 }} open={AlertStore.visible} closable={false}>
        <Box sx={{ p: 4 }}>
          <DialogTitle>{AlertStore.header}</DialogTitle>
          <DialogContent>
            {AlertStore.contentHeader ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 2,
                  gap: 1
                }}
              >
                {faIcon && <Icon name={faIcon} />}
                <Text variant="h5">{AlertStore.contentHeader}</Text>
              </Box>
            ) : null}
            {AlertStore.content}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={
                AlertStore.onCancel
                  ? () => AlertStore.onCancel()
                  : () => resetAlert()
              }
            >
              {AlertStore.cancelText}
            </Button>
            <Button
              onClick={
                AlertStore.onOk ? () => AlertStore.onOk() : () => resetAlert()
              }
            >
              {AlertStore.okText}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    )
  }
}

const AlertContainer = () => {
  const AlertStore = useAlert()
  const { resetAlert } = useAlertActions()

  return <Alert AlertStore={AlertStore} resetAlert={resetAlert} />
}

export default AlertContainer
